import { isNil, prop } from "ramda";

import { Error } from "gql";

export const translateErrorMessages = (messages: Record<string, string>) => {
  return (error: Error): Error =>
    isNil(error.message) || isNil(prop(error.message)(messages))
      ? error
      : { ...error, message: prop(error.message)(messages) };
};
